import { observer } from 'mobx-react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';

import type React from 'react';

import { ValueMeasurementRow } from '@/components/boxes/measurementBoxes/ValueMeasurementBox/ValueMeasurementRow.tsx';

export interface ValueMeasurementProps {
  label: string;
  descriptor: string;
  details: unknown;
}

interface ValueMeasurementBoxProps {
  measurements: Array<ValueMeasurementProps>;
  hasCriteria: boolean | undefined;
}

export const ValueMeasurementBox: React.FC<ValueMeasurementBoxProps> = observer(({ measurements, hasCriteria }) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="a dense table" size="small">
        <TableBody>
          {measurements.map((measurement: ValueMeasurementProps, index) => (
            <ValueMeasurementRow key={index} measurement={measurement} hasCriteria={hasCriteria} index={index} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
});
